import { Component, createResource, For, Show } from "solid-js";
import { A } from "@solidjs/router";
import { api } from "../auth";

const Home: Component = () => {
  const [races] = createResource(() => api<{ races: any[]; total: number }>("/api/races?limit=25"));

  return (
    <>
      <h1>Race cards and results</h1>
      <p class="muted">
        HKJC cards and results update automatically. Click any race for the
        full card, odds history, and model output (paid tier).
      </p>
      <Show when={!races.loading} fallback={<p>Loading...</p>}>
        <Show when={races()?.races?.length} fallback={<p>The automatic data import has not published any races yet.</p>}>
          <div class="card" style="padding: 0;">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Track</th>
                  <th>Distance</th>
                  <th>Going</th>
                  <th>Field</th>
                  <th>Source</th>
                </tr>
              </thead>
              <tbody>
                <For each={races()!.races}>
                  {(r) => (
                    <tr>
                      <td>{r.date ?? "?"}</td>
                      <td><A href={`/races/${r.race_id}`}>{r.track_name ?? r.track_id}</A></td>
                      <td>{r.distance_m ? `${r.distance_m}m` : "?"}</td>
                      <td>{r.going ?? "?"}</td>
                      <td>{r.field_size ?? "?"}</td>
                      <td><span class="badge">{r.source}</span></td>
                    </tr>
                  )}
                </For>
              </tbody>
            </table>
          </div>
          <p class="muted">Total in DB: {races()!.total}</p>
        </Show>
      </Show>
    </>
  );
};

export default Home;
